import { debounce } from '../debounce';
const preventDef = (e) => {
    e.preventDefault();
    e.stopPropagation();
};
const mouseAndWheelHorizontalScrollEvents = {
    mousedown: (event) => {
        const target = event.currentTarget;
        let pageX = 0;
        const mouseMove = (e) => {
            if (pageX !== 0) {
                event.preventDefault();
                target.style.pointerEvents = 'none';
                target.scrollLeft += pageX - e.pageX;
            }
            pageX = e.pageX;
        };
        const mouseUp = () => {
            document.removeEventListener('mousemove', mouseMove);
            document.removeEventListener('mouseup', mouseUp);
            target.removeEventListener('dragstart', preventDef);
            target.style.pointerEvents = '';
        };
        document.addEventListener('mousemove', mouseMove);
        document.addEventListener('mouseup', mouseUp);
        target.addEventListener('dragstart', preventDef);
    },
    wheel: (event) => {
        const target = event.currentTarget;
        let m = 1;
        if (event.deltaMode === event.DOM_DELTA_LINE) {
            m = parseInt(getComputedStyle(target).lineHeight);
        }
        else if (event.deltaMode === event.DOM_DELTA_PAGE) {
            m = target.clientHeight;
        }
        if (event.deltaY !== 0) {
            target.scrollLeft += event.deltaY * m;
            event.preventDefault();
        }
    }
};
const addScrollWithMouse = (wrapper) => {
    wrapper.addEventListener('mousedown', mouseAndWheelHorizontalScrollEvents.mousedown);
};
const mouseSwipe = (event, swipeHandle) => {
    const target = event.currentTarget;
    const startX = event.pageX;
    let endX = startX;
    const threshold = 30;
    const dSwipeHandle = debounce(swipeHandle);
    const mouseMove = (e) => {
        event.preventDefault();
        target.style.pointerEvents = 'none';
        endX = e.pageX;
        const distance = startX - endX;
        if (distance > threshold) {
            dSwipeHandle('swipedLeft');
        }
        else if (distance < -threshold) {
            dSwipeHandle('swipedRight');
        }
    };
    const mouseUp = () => {
        document.removeEventListener('mousemove', mouseMove);
        document.removeEventListener('mouseup', mouseUp);
        target.removeEventListener('dragstart', preventDef);
        target.style.pointerEvents = '';
    };
    document.addEventListener('mousemove', mouseMove);
    document.addEventListener('mouseup', mouseUp);
    target.addEventListener('dragstart', preventDef);
};
export { mouseAndWheelHorizontalScrollEvents, addScrollWithMouse, mouseSwipe };
